/* eslint-disable */
import React, {useState, memo, useEffect, useRef} from 'react';
import moment from 'moment';
import {diff} from 'deep-object-diff';
import T from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {Form, Formik, FieldArray} from 'formik';
import {ConnectedFocusError} from 'focus-formik-error';
import {RadioGroup} from '@material-ui/core';
import {useHistory} from 'react-router-dom';
import cn from 'classnames';
import {toast} from 'react-toastify';
import {
  getLocationLoading,
  locationData,
  locationId,
  locations,
  aggregationPlatformNames,
  aggregationPlatformSettings
} from 'store/locationSettings/selectors';
import {
  DashboardDisableStore,
  DashboardField,
  DashboardFieldInner,
  DashboardFieldLabel,
  DashboardFields,
  DashboardFormWrapper,
  DashboardHolder,
  DashboardInnerDescription,
  DashboardStoreToggleSection,
  DashboardStoreToggleWrapper,
  DashboardText,
  DashboardTimeDelete,
  DashboardTimeInner,
  DashboardTitle,
  DialogLinkButton,
  FieldLabel
} from 'routes/App/dashboard/styles';
import Loading from 'components/shared/Utils/Loading';
import {
  UPDATE_LOCATION_SETTINGS_DATA,
  POST_LOCATION_SETTINGS_DATA,
  OPEN_CONFIRMATION_MODAL,
  OPEN_DISABLE_MODAL,
  PUBLISH_LOCATION,
  OPEN_CHANGE_ADDRESS_CONFIRMATION_MODAL,
  SET_STATUS_BUTTON,
  GET_SPECIAL_HOURS,
  DELETE_SPECIAL_HOURS,
  CREATE_SPECIAL_HOURS,
  GET_AGGREGATION_PLATFORM_SETTINGS,
  GET_SELF_DELIVERY_REPORT_EMAIL,
  UPDATE_SELF_DELIVERY_REPORT_EMAIL
} from 'store/locationSettings/action';
import FieldInput from 'components/FieldInput';
import CheckboxS2E from 'components/Checkbox';
import {ButtonInfo, ButtonPrimary, ButtonOutline} from 'components/buttons';
import RadioS2E from 'components/Radiobox';
import AutocompletedMapField from 'routes/App/settings/LocationMap/AutocompletedMapField';
import LocationMap from 'routes/App/settings/LocationMap/LocationMap';
import SwitchS2E from 'components/Switch';
import LocationConfirmationModal from 'routes/App/settings/Modals/LocationConfirmationModal';
import LocationDisableModal from 'routes/App/settings/Modals/LocationDisableModal';
import {mapProps} from 'routes/App/settings/constants';
import {
  isLocationNameUnique,
  openingDaysServerParser,
  isOpeningHoursChange,
  refreshClosingTime,
  changeTimeToFitWorkingHours
} from 'routes/App/settings/helpers';
import DaysPickerContainer from 'routes/App/settings/DaysPickerContainer';
import {useDaysPickerContext} from 'routes/App/settings/context/DaysPickerContext';
import {useDeliveryHoursContext} from 'routes/App/settings/DeliveryHoursPicker/context/DaysPickerContext';
import {ErrorSign, ErrorSignWrapper} from 'components/errorSign/errorSign';
import StoreSettingsSchema from 'helpers/services/formValidationSchemas/StoreSettingsSchema';
import {maxLenFormatter} from 'helpers/functionUtils/helpFunctions';
import FileUploader from 'components/FileUploader';
import {
  countryCodeFormatter,
  etaFormatter,
  phoneNumberFormatter,
  taxFormatter
} from 'helpers/functionUtils/helpFunctions';
import {FlexContainer, FlexItem} from 'components/layout';
import FieldMaskInput from 'components/FieldMaskInput';
import {
  LocationFormActions,
  StoreDisabledBanner,
  SpecialHoursEntry,
  StoreAvailabilityRow,
  StoreAvailabilityBlockLeft,
  StoreAvailabilityBlockTitle,
  StoreAvailabilityBlockDesc,
  OrderingChannelDividerLine,
  MenuBannerField,
  SelfDeliveryReportEmailHint
} from 'routes/App/settings/styles';
import AddSpecialHoursModal from 'routes/App/settings/Modals/AddSpecialHoursModal';
import SaveButton from 'assets/SaveButton';
import Textarea from 'components/FieldTextarea/style';
import validateEtaDuration from 'routes/App/settings/helpers/ValidateEtaDuration';
import ButtonClear from 'components/buttons/ButtonClear/styles';
import sendGtmEvent from 'helpers/services/utils/gtm';
import ButtonSaveScroll from 'components/buttons/ButtonSave';
import RouteLeavingGuardNew from 'helpers/RouteLeavingGuardNew';
import {
  SHOW_PUBLISH_PROGRESSBAR,
  SHOW_UNPUBLISH_BANNER,
  STOP_GET_PUBLISH_STATUS_JOB
} from 'store/global/globalNotifications/action';
import IconSaveDisk from 'assets/IconSaveDisk';
import ButtonBold from 'components/buttons/ButtonBold/styles';
import {UNPUBLISH_BANNER_SETTINGS_TYPE} from 'store/global/globalNotifications/constants';
import ChangeAddressConfirmationModal from 'routes/App/settings/Modals/ChangeAddressConfirmationModal';
import SelfDeliveryReportEmailChangeModal from 'routes/App/settings/Modals/SelfDeliveryReportEmailChangeModal';
import StorefrontQrCode from 'routes/App/settings/LocationForm/StorefrontQrCode';
import BillingBank from 'routes/App/settings/LocationForm/BillingBank';
import {getSessionStorageItem} from 'helpers/sessionStorage';
import SESSION_SAUCE_EMPLOYEE_NAME from 'helpers/sessionStorage/constants';
import DeliveryDaysPickerContainer from 'routes/App/settings/DeliveryHoursPicker/DaysPickerContainer';
import {
  buildDisableWarningFromPlatformNames,
  buildAvailabilityWarning,
  CHANNEL_SELECTION_AVAILABILITY_WARNING
} from 'helpers/functionUtils/storeSettings';
import {FEATURE_RESTRICTION_IDS} from 'helpers/constants/restrictions';
import IconTrashRed from 'assets/icon-trash-red.svg';
import OrderingChannels from 'routes/App/settings/LocationForm/OrderingChannels';

const getServiceDisabledHint = (timestamp, msg, data) => {
  timestamp =
    typeof timestamp === 'object'
      ? Number(Date.parse(timestamp)) / 1000
      : timestamp;

  let text = msg || 'Disabled';

  if (timestamp) {
    text += ' until ' + moment.unix(timestamp).utc().format('MM/DD/YYYY HH:mm');
  }

  return text;
};

const LocationForm = ({isCreating, setIsCreating}) => {
  const formikRef = useRef();
  const openingDays = useDaysPickerContext();
  const deliveryDays = useDeliveryHoursContext();
  const merchantLocations = locations();
  const showUnPublishBannerType = useSelector(
    (state) => state.globalNotificationsReducer.unPublishBanner.type
  );
  const history = useHistory();
  const dispatch = useDispatch();
  const [map, setMap] = useState(null);
  const [mapMarker, setMapMarker] = useState(null);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const loading = getLocationLoading();
  const locId = locationId();
  const platformNames = aggregationPlatformNames();
  const platformSettings = aggregationPlatformSettings();

  const {AllowedServiceFeatures} = useSelector(
    (state) => state.user.activeLocation
  );
  const activeLocation = useSelector((state) => state.user.activeLocation);
  const hasChannelSelection = AllowedServiceFeatures?.includes(
    FEATURE_RESTRICTION_IDS.PAUSE_ORDER_CHANNELS_SELECTION
  );

  const isBankAccountUpdateEnabled = AllowedServiceFeatures?.includes(
    FEATURE_RESTRICTION_IDS.BYOC_BANK_ACCOUNT_UPDATE
  );
  const isByocLocation =
    activeLocation?.IsByocOnly === true ||
    activeLocation?.isByocOnly === true ||
    AllowedServiceFeatures?.includes(FEATURE_RESTRICTION_IDS.BYOC_ONBOARDING) ||
    AllowedServiceFeatures?.includes(FEATURE_RESTRICTION_IDS.BYOC);
  const showBillingBank = isBankAccountUpdateEnabled && isByocLocation;

  const showSelfDeliveryReportEmail = AllowedServiceFeatures?.includes(
    FEATURE_RESTRICTION_IDS.BYOC
  );
  const userRole = useSelector((state) => state.user.userData?.role);
  const canUpdateSelfDeliveryReportEmail =
    userRole === 'admin' || userRole === 'sudo';

  const [messageUnPublish, setMessageUnPublish] = useState(false);
  const computedAddTaxButtonClasses = (taxPercents) => {
    const haveEmptyTax = Boolean(taxPercents.find((elem) => elem.Value === ''));
    if (haveEmptyTax || taxPercents.length >= 5) {
      return 'disabled';
    }

    return '';
  };

  const [showCancelHolidaysModal, setShowCancelHolidaysModal] = useState(false);
  const [hideBannerHolidays, setHideBannerHolidays] = useState(false);
  const [valuesHolidays, setValuesHolidays] = useState();
  const [addSpecialHoursModalOpen, setAddSpecialHoursModalOpen] = useState(
    false
  );
  const [
    selfDeliveryEmailChangeRequestLoading,
    setSelfDeliveryEmailChangeRequestLoading
  ] = useState(false);
  const [
    selfDeliveryEmailChangeModalOpen,
    setSelfDeliveryEmailChangeModalOpen
  ] = useState(false);
  const [specialHoursList, setSpecialHoursList] = useState([]);

  const activeOrders = useSelector(
    (state) => state.activeOrdersReducer.activeOrders
  );

  const activeOrdersV2 = useSelector(
    (state) => state.activeOrdersV2Reducer.activeOrders
  );

  const isDisableModalFutureOrders = useSelector(
    (state) => state.locationSettingsReducer.isDisableModalFutureOrders
  );
  const {isChangeAddressModalOpen} = useSelector(
    (state) => state.locationSettingsReducer
  );

  const {
    data,
    disableButton,
    specialHours,
    specialHoursLoading,
    createSpecialHoursLoading,
    deleteSpecialHoursLoading,
    aggregationPlatformSettingsLoading,
    selfDeliveryReportEmail,
    selfDeliveryReportEmailLoading,
    bankAccountConnected,
    bankAccountLast4,
    bankAccountCompanyFound
  } = useSelector((state) => state.locationSettingsReducer);

  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const closePublishMessage = () => {
    setMessageUnPublish(false);
    setConfirmedNavigation(true);
  };

  const checkIfSauceEmployee = () => {
    return getSessionStorageItem(SESSION_SAUCE_EMPLOYEE_NAME);
  };

  const publishLocation = () => {
    dispatch(
      PUBLISH_LOCATION({
        preCallback: () => {
          dispatch(SHOW_UNPUBLISH_BANNER({showBanner: false, types: []}));
          dispatch(SHOW_PUBLISH_PROGRESSBAR(true));
        },
        postCallBack: () => {},
        errorCallback: () => {
          dispatch(STOP_GET_PUBLISH_STATUS_JOB());
          dispatch(SHOW_PUBLISH_PROGRESSBAR(false));
        }
      })
    );
  };

  useEffect(() => {
    if (data) {
      dispatch(SET_STATUS_BUTTON(false));
    }
  }, [data]);

  useEffect(() => {
    if (data?._id) setValuesHolidays(false);
  }, [data?._id]);

  useEffect(() => {
    if (data?.StoreHolidays && !Object?.keys(data?.StoreHolidays)?.length) {
      setValuesHolidays(false);
    }
  }, [data?.StoreHolidays]);

  useEffect(() => {
    if (
      activeLocation?._id &&
      AllowedServiceFeatures?.includes(FEATURE_RESTRICTION_IDS.HOLIDAY_HOURS_V2)
    ) {
      dispatch(GET_SPECIAL_HOURS());
    }
  }, [activeLocation?._id]);

  useEffect(() => {
    if (activeLocation?._id) {
      dispatch(GET_AGGREGATION_PLATFORM_SETTINGS());
    }
  }, [activeLocation?._id]);

  useEffect(() => {
    if (
      activeLocation?._id &&
      (showBillingBank || showSelfDeliveryReportEmail)
    ) {
      dispatch(GET_SELF_DELIVERY_REPORT_EMAIL());
    }
  }, [activeLocation?._id, showBillingBank, showSelfDeliveryReportEmail]);

  useEffect(() => {
    if (Array.isArray(specialHours)) {
      setSpecialHoursList(specialHours);
    }
  }, [specialHours]);

  // Keep formik pause fields in sync with server/redux after pause/unpause
  useEffect(() => {
    if (!formikRef.current || !data) return;
    const {values, setFieldValue} = formikRef.current;
    if (
      data.ExternalOrderProviders &&
      data.ExternalOrderProviders !== values.ExternalOrderProviders
    ) {
      setFieldValue(
        'ExternalOrderProviders',
        data.ExternalOrderProviders,
        false
      );
    }
    if (
      typeof data.ClosedManually === 'boolean' &&
      data.ClosedManually !== values.ClosedManually
    ) {
      setFieldValue('ClosedManually', data.ClosedManually, false);
      setFieldValue(
        'ClosedManuallyUntilTime',
        data.ClosedManuallyUntilTime,
        false
      );
      setFieldValue('ClosedManuallyReason', data.ClosedManuallyReason, false);
      setFieldValue('ClosedManuallyTime', data.ClosedManuallyTime, false);
      setFieldValue('StoreDisableOption', data.StoreDisableOption, false);
    }
  }, [
    data?.ExternalOrderProviders,
    data?.ClosedManually,
    data?.ClosedManuallyUntilTime
  ]);

  useEffect(() => {
    if (formikRef.current && !isCreating && !messageUnPublish) {
      const {
        values,
        resetForm,
        setFieldValue,
        isSubmitting
      } = formikRef.current;

      // if (!isSubmitting) {
      //   resetForm({...values});
      // }
      setFieldValue('OpeningHoursChanged', values.OpeningHoursChanged);
      if (AllowedServiceFeatures.includes('delivery_hours')) {
        setFieldValue('DeliveryHoursChanged', values.DeliveryHoursChanged);
      }
    }
  }, [formikRef.current]);

  const {
    FullName,
    Phone,
    Email,
    CustomErrorMessage,
    PickupEtaMinutes,
    EtaMinutes,
    Say2eatDispatch,
    InhouseDelivery,
    Latitude,
    Longitude,
    TaxPercents,
    AlcoholTax,
    DeliveryOptions,
    DeliveryEnableIn,
    PickupEnableIn,
    PickupDisableReason,
    PickupDisableOption,
    DeliveryDisableReason,
    DeliveryDisableOption,
    OpeningHours,
    DeliveryHours,
    DeliveryHoursSuchAsOpeningHours,
    DeliveryAreaType,
    Timezone,
    Address,
    WorkingDays,
    DeliveryDays,
    ClosedManually,
    ClosedManuallyUntilTime,
    ClosedManuallyTime,
    notSyncedData,
    ClosedManuallyReason,
    StoreDisableOption,
    // MailForHumanResponseMessage = '',
    StructuredAddress,
    Reports,
    ExternalOrderProviders,
    MenuBannerText
  } = locationData();

  const openSelfDeliveryEmailChangeModal = () => {
    setSelfDeliveryEmailChangeModalOpen(true);
  };

  const closeSelfDeliveryEmailChangeModal = () => {
    if (selfDeliveryEmailChangeRequestLoading) {
      return;
    }
    setSelfDeliveryEmailChangeModalOpen(false);
  };

  const submitSelfDeliveryReportEmailChange = (newEmail) => {
    if (selfDeliveryEmailChangeRequestLoading) {
      return;
    }
    setSelfDeliveryEmailChangeRequestLoading(true);
    dispatch(
      UPDATE_SELF_DELIVERY_REPORT_EMAIL({
        newEmail,
        locationId: activeLocation?._id,
        successCallback: () => {
          setSelfDeliveryEmailChangeRequestLoading(false);
          setSelfDeliveryEmailChangeModalOpen(false);
        },
        errorCallback: () => setSelfDeliveryEmailChangeRequestLoading(false)
      })
    );
  };

  const initValues = () =>
    isCreating
      ? {
          FullName: '',
          Phone: '',
          CountryCode: '+1',
          Email: '',
          ClosedManually: false,
          CustomErrorMessage: '',
          PickupEtaMinutes: 15,
          DeliveryOptions: {
            Pickup: false,
            Delivery: false,
            IsCatering: false,
            Curbside: false,
            CurbsideInstructions: 'Please send us your car model and color',
            CurbsideAdditionalInformation: 'Car: '
          },
          OpeningDays: 'allDays',
          EtaMinutes: 60,
          Say2eatDispatch: true,
          InhouseDelivery: false,
          Address: '',
          City: '',
          Country: '',
          State: '',
          ZipCode: '',
          Location: '',
          GoogleMapURL: '',
          FullAddress: '',
          PlaceId: '',
          Latitude: 0,
          Longitude: 0,
          TaxPercents: [],
          AlcoholTax: 0,
          DeliveryAreaType: '',
          MailForWeeklyReport: '',
          StreetNumber: '',
          StructuredAddress: {},
          MenuBannerText: ''
          // MailForHumanResponseMessage: ''
        }
      : {
          FullName,
          Phone: phoneNumberFormatter(
            Phone?.includes('+1') ? Phone?.split('+1')[1] : Phone
          ),
          CountryCode: '+1',
          Email,
          ClosedManually,
          CustomErrorMessage,
          ClosedManuallyTime,
          PickupEtaMinutes: String(PickupEtaMinutes),
          DeliveryOptions: {
            ...DeliveryOptions,
            CurbsideInstructions:
              DeliveryOptions?.CurbsideInstructions ||
              'Please send us your car model and color',
            CurbsideAdditionalInformation:
              DeliveryOptions?.CurbsideAdditionalInformation || 'Car: '
          },
          EtaMinutes,
          Say2eatDispatch,
          InhouseDelivery,
          Latitude,
          Longitude,
          TaxPercents,
          DeliveryAreaType,
          Timezone,
          Address,
          notSyncedData,
          OpeningHoursChanged: [],
          DeliveryHoursChanged: [],
          DeliveryHoursSuchAsOpeningHours,
          ClosedManuallyReason,
          PickupDisableReason,
          PickupDisableOption,
          DeliveryDisableReason,
          DeliveryEnableIn,
          PickupEnableIn,
          ClosedManuallyUntilTime,
          StoreDisableOption,
          DeliveryDisableOption,
          // TODO: Dirty hack duplicate to avoid address validation error on form load
          FullAddress: Address,
          PlaceId: '',
          City: Address,
          StreetNumber: Address,
          AlcoholTax: parseFloat(AlcoholTax),
          MailForWeeklyReport:
            Array.isArray(Reports?.SalesSummary?.Emails) &&
            Reports?.SalesSummary?.Emails?.length > 0
              ? Reports?.SalesSummary?.Emails?.join(', ')
              : '',
          Reports,
          StructuredAddress,
          ExternalOrderProviders,
          MenuBannerText: MenuBannerText || ''
          // MailForHumanResponseMessage
        };

  const getOppositeServiceValue = (currentType) => {
    return currentType === 'Pickup' ? 'Delivery' : 'Pickup';
  };

  const onServiceChange = (type, values) => {
    if (
      !values.DeliveryOptions[getOppositeServiceValue(type)] &&
      values.DeliveryOptions[type]
    ) {
      toast.error(
        'You cannot disable both options: Pickup & Sauce Delivery. One of the options should be enabled!'
      );
      return;
    }

    if (!values.DeliveryOptions[type]) {
      dispatch(
        OPEN_CONFIRMATION_MODAL({
          open: true,
          entityName: type
        })
      );
    } else {
      dispatch(
        OPEN_DISABLE_MODAL({
          open: true,
          entityName: type
        })
      );
    }
  };

  if (
    loading ||
    specialHoursLoading ||
    aggregationPlatformSettingsLoading ||
    ((showBillingBank || showSelfDeliveryReportEmail) &&
      selfDeliveryReportEmailLoading) ||
    (data?._id && data._id !== locId)
  ) {
    return <Loading />;
  }

  const initialValues = initValues();

  const shouldAllowFormReinitialize = diff(
    initialValues,
    formikRef?.current?.values
  );

  const closeChangeAddressConfirmationModal = () => {
    dispatch(OPEN_CHANGE_ADDRESS_CONFIRMATION_MODAL({open: false}));
  };

  return (
    <Formik
      enableReinitialize={
        !Object.keys(shouldAllowFormReinitialize || {}).length
      }
      innerRef={formikRef}
      initialValues={initialValues}
      validationSchema={StoreSettingsSchema}
      onSubmit={(fields, {setFieldError, setFieldValue, resetForm}) => {
        setFormSubmitting(true);

        if (
          isLocationNameUnique(fields.FullName, merchantLocations, FullName)
        ) {
          setFormSubmitting(false);
          setFieldError(
            'FullName',
            'Location name must be unique across merchant!'
          );
          return;
        }

        const {
          City,
          Country,
          FullAddress,
          Location,
          State,
          ZipCode,
          OpeningHoursChanged,
          DeliveryHoursChanged,
          StreetNumber,
          DeliveryHoursSuchAsOpeningHours,
          ...usefulFormData
        } = fields;

        const hours = openingDaysServerParser(openingDays);
        const deliveryHours = openingDaysServerParser(deliveryDays);

        usefulFormData.Phone = Phone.includes('+1')
          ? `${usefulFormData.CountryCode || '+1'}${fields.Phone}`
          : fields?.Phone;

        const formData = {
          ...usefulFormData,
          //[Rounding
          Latitude: parseFloat(Number(usefulFormData.Latitude).toFixed(7)) || 0,
          Longitude:
            parseFloat(Number(usefulFormData.Longitude).toFixed(7)) || 0,
          //]
          PickupEtaMinutes: parseFloat(usefulFormData.PickupEtaMinutes),
          EtaMinutes: parseFloat(usefulFormData.EtaMinutes),
          AlcoholTax: parseFloat(usefulFormData.AlcoholTax) || 0,
          OpeningHours: hours,
          ...(AllowedServiceFeatures.includes('delivery_hours') &&
          !DeliveryHoursSuchAsOpeningHours
            ? {DeliveryHours: deliveryHours}
            : {DeliveryHours: openingDaysServerParser(DeliveryDays)}),
          MailForWeeklyReport:
            usefulFormData?.MailForWeeklyReport?.trim()
              .replace(/,/g, ';')
              .split(' ')
              .join('') || null,
          MenuBannerText: usefulFormData?.MenuBannerText?.trim() || '',
          DeliveryHoursSuchAsOpeningHours
        };

        // if (usefulFormData?.ClosedManuallyUntilTime) {
        //   formData.ClosedManuallyUntilTime = changeTimeToFitWorkingHours(
        //     usefulFormData?.ClosedManuallyUntilTime,
        //     hours
        //   );
        //
        //   // The next string is for prevent reset time in UI to fields.PickupEnableIn after submitting,
        //   // so user can see correct time when feature will be enabled
        //   fields.ClosedManuallyUntilTime = formData.ClosedManuallyUntilTime;
        // }

        if (usefulFormData?.PickupEnableIn) {
          formData.PickupEnableIn =
            PickupDisableOption === 'Until Next Opening Time'
              ? refreshClosingTime(
                  'PickupEnableIn',
                  fields?.Timezone,
                  hours,
                  setFieldValue
                )()
              : usefulFormData.PickupEnableIn;

          // The next string is for prevent reset time in UI to fields.PickupEnableIn after submitting,
          // so user can see correct time when feature will be enabled
          fields.PickupEnableIn = formData.PickupEnableIn;
        }

        if (usefulFormData?.DeliveryEnableIn) {
          formData.DeliveryEnableIn =
            DeliveryDisableOption === 'Until Next Opening Time'
              ? refreshClosingTime(
                  'DeliveryEnableIn',
                  fields?.Timezone,
                  hours,
                  setFieldValue
                )()
              : usefulFormData.DeliveryEnableIn;

          // The next string is for prevent reset time in UI to fields.DeliveryEnableIn after submitting,
          // so user can see correct time when feature will be enabled
          fields.DeliveryEnableIn = formData.DeliveryEnableIn;
        }

        if (isOpeningHoursChange(OpeningHours, hours)) {
          if (!AllowedServiceFeatures.includes('delivery_hours')) {
            formData.DeliveryHoursSuchAsOpeningHours = true;
          }
        }

        if (hours.length) {
          if (validateEtaDuration(hours, usefulFormData?.EtaMinutes)) {
            setFormSubmitting(false);
            setFieldError(
              'EtaMinutes',
              'ETA cannot be greater than (or equal) duration of working hours! Please change ETA or restaurant working hours.'
            );

            return;
          }

          if (isCreating) {
            dispatch(
              POST_LOCATION_SETTINGS_DATA({
                payload: formData,
                successCallback: () => setFormSubmitting(false)
              })
            );
            setIsCreating(false);
          } else {
            let dataToPost = diff(initialValues, formData);
            if (dataToPost.StructuredAddress) {
              dataToPost.StructuredAddress = {
                ...formData.StructuredAddress,
                Latitude:
                  parseFloat(
                    Number(formData.StructuredAddress.Latitude).toFixed(7)
                  ) || 0,
                Longitude:
                  parseFloat(
                    Number(formData.StructuredAddress.Longitude).toFixed(7)
                  ) || 0
              };
            }
            // Reset Arrays by full values (don't need a diff format for now)
            Object.keys(formData).forEach((key) => {
              if (Array.isArray(formData[key]) && !!dataToPost[key]) {
                dataToPost[key] = formData[key];
              }
            });

            if (dataToPost.ExternalOrderProviders) {
              dataToPost.ExternalOrderProviders =
                formData.ExternalOrderProviders;
            }

            dispatch(
              UPDATE_LOCATION_SETTINGS_DATA({
                payload: dataToPost,
                successCallback: () => {
                  setFormSubmitting(false);
                  resetForm({values: fields});
                  publishLocation();
                  if (fields.hasOwnProperty('storeHolidays')) {
                    setFieldValue('storeHolidays', undefined);
                  }
                },
                errorCallback: () => {
                  setFormSubmitting(false);
                  resetForm({values: fields});
                  dispatch(STOP_GET_PUBLISH_STATUS_JOB());
                  dispatch(SHOW_PUBLISH_PROGRESSBAR(false));
                }
              })
            );
          }
        }
      }}
    >
      {({
        values,
        handleChange,
        setFieldValue,
        dirty,
        errors,
        touched,
        handleBlur,
        setErrors,
        submitForm,
        resetForm
      }) => {
        return (
          <DashboardFormWrapper>
            <Form id='store-settings-form'>
              <ConnectedFocusError />
              <DashboardDisableStore className={ClosedManually && 'disabled'}>
                <DashboardHolder className='LocationForm'>
                  <DashboardFields>
                    <DashboardField className='w100 dFlex'>
                      <DashboardFieldLabel>
                        <FieldLabel className='FieldLabelLg'>
                          Location Name
                        </FieldLabel>
                      </DashboardFieldLabel>

                      {/* <RouteLeavingGuard */}
                      {/* when={dirty || lastUpdatedForm > lastBotSync} */}
                      {/* titleText={ */}
                      {/*   dirty */}
                      {/*     ? 'Close without saving?' */}
                      {/*     : 'Close without publishing?' */}
                      {/* }*/}
                      {/* contextText={ */}
                      {/*   dirty */}
                      {/*     ? 'You have unsaved changes. Are you sure you want to leave this page without saving?' */}
                      {/*     : 'You have unpublished changes. Are you sure you want to leave now?' */}
                      {/* }*/}
                      {/* navigate={(path) => { */}
                      {/*   history.push(path); */}
                      {/*   if (dirty) { */}
                      {/*     sendGtmEvent('storeSettingsUnsavedChanges', { */}
                      {/*       unsaved: true */}
                      {/*     });*/}
                      {/*   } else {*/}
                      {/*     sendGtmEvent('storeSettingsUnpublishedChanges', { */}
                      {/*       unPublished: true */}
                      {/*     }); */}
                      {/*   } */}
                      {/* }} */}
                      {/* /> */}

                      <LocationConfirmationModal
                        setFieldValue={setFieldValue}
                        values={values}
                        closedManually={ClosedManually}
                        dispatch={dispatch}
                        resetForm={resetForm}
                        setFormSubmitting={setFormSubmitting}
                        disableButton={disableButton}
                        externalOrderProviders={
                          values.ExternalOrderProviders ||
                          ExternalOrderProviders
                        }
                      />
                      <LocationDisableModal
                        setGlobalFieldValue={setFieldValue}
                        openingHours={OpeningHours}
                        showCancelHolidaysModal={showCancelHolidaysModal}
                        setShowCancelHolidaysModal={setShowCancelHolidaysModal}
                        setHideBannerHolidays={setHideBannerHolidays}
                        data={data}
                        setValuesHolidays={setValuesHolidays}
                        setFormSubmitting={setFormSubmitting}
                        locationValues={values}
                        dispatch={dispatch}
                        disableButton={disableButton}
                        externalOrderProviders={
                          values.ExternalOrderProviders ||
                          ExternalOrderProviders
                        }
                        disableWarningText={buildDisableWarningFromPlatformNames(
                          platformNames
                        )}
                      />
                      <ChangeAddressConfirmationModal
                        openModal={isChangeAddressModalOpen}
                        isCloseConfirmModal={
                          closeChangeAddressConfirmationModal
                        }
                        fullAddress={values.FullAddress}
                        initValuesAddress={initialValues.FullAddress}
                        checkActiveOrders={
                          !!activeOrders?.length || !!activeOrdersV2?.length
                        }
                      />
                      {canUpdateSelfDeliveryReportEmail && (
                        <SelfDeliveryReportEmailChangeModal
                          open={selfDeliveryEmailChangeModalOpen}
                          currentEmail={selfDeliveryReportEmail || ''}
                          isSubmitting={selfDeliveryEmailChangeRequestLoading}
                          onClose={closeSelfDeliveryEmailChangeModal}
                          onSubmit={submitSelfDeliveryReportEmailChange}
                        />
                      )}
                      <DashboardFieldInner className='w60'>
                        <FieldInput
                          type='text'
                          value={values.FullName}
                          onChange={(e) => {
                            const formattedString = e.target.value.replace(
                              /[!@#$%^&+*]/g,
                              ''
                            );
                            setFieldValue('FullName', formattedString);
                          }}
                          name='FullName'
                          placeholder='Location Name'
                          className={errors.FullName && 'error'}
                        />
                        <ErrorSignWrapper leftPosition='211px'>
                          <ErrorSign>
                            {errors.FullName && errors.FullName}
                          </ErrorSign>
                        </ErrorSignWrapper>
                      </DashboardFieldInner>
                    </DashboardField>
                  </DashboardFields>
                </DashboardHolder>
              </DashboardDisableStore>
              <DashboardStoreToggleSection>
                <DashboardTitle className='WithLine mBottom titleMd'>
                  Store Availability
                </DashboardTitle>
                <DashboardInnerDescription className='withIcon GreyText marginB15'>
                  <span>
                    {hasChannelSelection
                      ? CHANNEL_SELECTION_AVAILABILITY_WARNING
                      : buildAvailabilityWarning(platformNames)}
                  </span>
                </DashboardInnerDescription>
                {hasChannelSelection ? (
                  <OrderingChannels
                    closedManually={ClosedManually}
                    externalPlatforms={platformSettings}
                    externalOrderProviders={ExternalOrderProviders}
                  />
                ) : (
                  <StoreAvailabilityRow>
                    <StoreAvailabilityBlockLeft>
                      <StoreAvailabilityBlockTitle>
                        Pause temporarily for a few hours.
                      </StoreAvailabilityBlockTitle>
                    </StoreAvailabilityBlockLeft>
                    <ButtonOutline
                      className='ButtonSmall'
                      type='button'
                      onClick={() => {
                        if (ClosedManually) {
                          dispatch(
                            OPEN_CONFIRMATION_MODAL({
                              open: true,
                              entityName: 'Store'
                            })
                          );
                        } else {
                          dispatch(
                            OPEN_DISABLE_MODAL({
                              open: true,
                              entityName: 'Store'
                            })
                          );
                        }
                      }}
                    >
                      <span>{`${
                        ClosedManually ? 'Unpause' : 'Pause'
                      } orders`}</span>
                    </ButtonOutline>
                  </StoreAvailabilityRow>
                )}

                {AllowedServiceFeatures?.includes(
                  FEATURE_RESTRICTION_IDS.HOLIDAY_HOURS_V2
                ) && (
                  <>
                    {hasChannelSelection && <OrderingChannelDividerLine />}
                    <StoreAvailabilityRow>
                      <StoreAvailabilityBlockLeft>
                        <StoreAvailabilityBlockTitle>
                          Add special hours or closures for holidays, special
                          events, or other exceptional events.
                        </StoreAvailabilityBlockTitle>
                        <StoreAvailabilityBlockTitle>
                          This will temporarily replace your regular menu hours.
                        </StoreAvailabilityBlockTitle>
                      </StoreAvailabilityBlockLeft>
                      <ButtonOutline
                        className='ButtonSmall'
                        type='button'
                        onClick={() => setAddSpecialHoursModalOpen(true)}
                      >
                        <span>Add special hours</span>
                      </ButtonOutline>
                    </StoreAvailabilityRow>

                    {specialHoursList.length > 0 &&
                      specialHoursList
                        .slice()
                        .sort(
                          (a, b) => new Date(a.startsOn) - new Date(b.startsOn)
                        )
                        .map((item) => {
                          const startsOn = item.startsOn ?? item.StartsOn;
                          const endsOn = item.endsOn ?? item.EndsOn;
                          const startStr = moment(startsOn).format(
                            'MMM D, YYYY'
                          );
                          const endStr = moment(endsOn).format('MMM D, YYYY');
                          const isOneDay = moment(startsOn).isSame(
                            moment(endsOn),
                            'day'
                          );
                          const dateStr = isOneDay
                            ? startStr
                            : `${startStr} - ${endStr}`;
                          const timeStr =
                            item.type === 'closing_hours'
                              ? 'Closed all day'
                              : item.times?.length
                              ? item.times
                                  .map(
                                    (t) =>
                                      `${moment(
                                        `${t.start.hour}:${t.start.minute}`,
                                        'H:m'
                                      ).format('h:mm A')} - ${moment(
                                        `${t.end.hour}:${t.end.minute}`,
                                        'H:m'
                                      ).format('h:mm A')}`
                                  )
                                  .join(', ')
                              : '';
                          return (
                            <SpecialHoursEntry key={item.id}>
                              <div className='SpecialHoursText'>
                                {dateStr} <span>{timeStr}</span>
                              </div>

                              <DashboardTimeDelete
                                className={cn('', {
                                  disabled: deleteSpecialHoursLoading
                                })}
                                type='button'
                                onClick={() =>
                                  dispatch(DELETE_SPECIAL_HOURS(item.id))
                                }
                              />
                            </SpecialHoursEntry>
                          );
                        })}
                    <AddSpecialHoursModal
                      open={addSpecialHoursModalOpen}
                      onClose={() => setAddSpecialHoursModalOpen(false)}
                      onSave={(body) => {
                        dispatch(
                          CREATE_SPECIAL_HOURS({
                            body,
                            successCallback: () =>
                              setAddSpecialHoursModalOpen(false)
                          })
                        );
                      }}
                      existingSpecialHours={specialHoursList}
                      timezone={Timezone}
                      loading={createSpecialHoursLoading}
                    />
                  </>
                )}

                <DashboardDisableStore className={!ClosedManually && 'hide'}>
                  <DashboardFields>
                    <DashboardField className='w100 dFlex'>
                      <DashboardFieldLabel>
                        <FieldLabel className='FieldLabelLg'>
                          Closed Message
                        </FieldLabel>
                      </DashboardFieldLabel>
                      <DashboardFieldInner className='w60'>
                        <Textarea
                          style={{resize: 'none'}}
                          className='ClosedMessage'
                          value={values.CustomErrorMessage}
                          onChange={(event) =>
                            setFieldValue(
                              'CustomErrorMessage',
                              maxLenFormatter(
                                event.target.value,
                                values.CustomErrorMessage,
                                150
                              )
                            )
                          }
                          name='CustomErrorMessage'
                          placeholder='Closed Message'
                        />
                      </DashboardFieldInner>
                    </DashboardField>
                  </DashboardFields>
                </DashboardDisableStore>
              </DashboardStoreToggleSection>
              <DashboardDisableStore className={ClosedManually && 'disabled'}>
                {!hideBannerHolidays &&
                  data?.StoreHolidays?.disableStoreTime &&
                  data?.StoreHolidays?.enableStoreTime &&
                  !AllowedServiceFeatures?.includes(
                    FEATURE_RESTRICTION_IDS.HOLIDAY_HOURS_V2
                  ) && (
                    <StoreDisabledBanner>
                      <div className='StoreDisabledBannerRside'>
                        <div className='StoreDisabledBannerText'>
                          The store will not receive new orders between{' '}
                          {moment(data?.StoreHolidays?.disableStoreTime)
                            .utc()
                            .format('MMMM Do YYYY [at] h:mm A')}{' '}
                          until{' '}
                          {moment(data?.StoreHolidays?.enableStoreTime)
                            .utc()
                            .format('MMMM Do YYYY [at] h:mm A')}
                        </div>
                        {data?.StoreHolidays?.disableStoreTime &&
                          data?.StoreHolidays?.enableStoreTime && (
                            <DashboardText className='bottomText'>
                              <DialogLinkButton
                                onClick={() => setShowCancelHolidaysModal(true)}
                                className='Sm LinkButton'
                              >
                                Click here to cancel
                              </DialogLinkButton>{' '}
                              the future dates limitation and{' '}
                              <strong>receive new orders now.</strong>
                            </DashboardText>
                          )}
                      </div>
                    </StoreDisabledBanner>
                  )}
                <DashboardHolder>
                  <DashboardTitle className='WithLine mBottom titleMd'>
                    Services Enablement
                  </DashboardTitle>
                  <DashboardFields>
                    <DashboardField className='w100 dFlex AlignStart'>
                      <DashboardFieldLabel className='marginTopMd'>
                        <div>
                          <SwitchS2E
                            onChange={() => {
                              onServiceChange('Pickup', values);
                              setFieldValue('DeliveryOptions.Curbside', false);
                            }}
                            name='DeliveryOptions.Pickup'
                            checked={values.DeliveryOptions.Pickup}
                            label='Pickup'
                            labelPlacement='start'
                            isDisabled={
                              !checkIfSauceEmployee() && !InhouseDelivery
                            }
                          />
                          <ErrorSign>
                            {values?.DeliveryOptions?.Pickup === false &&
                              getServiceDisabledHint(values?.PickupEnableIn)}
                          </ErrorSign>
                        </div>
                      </DashboardFieldLabel>
                      <DashboardFieldInner
                        className={
                          !values.DeliveryOptions.Pickup
                            ? 'disabled dFlex flexColumn'
                            : 'dFlex flexAuto'
                        }
                      >
                        <DashboardFields>
                          <DashboardField className='w100 dFlex'>
                            <DashboardText className='bold mRight20 mobMinRight mobFixWidth'>
                              Food Preparation Time
                            </DashboardText>
                            <FieldInput
                              disabled={!values.DeliveryOptions.Pickup}
                              className={cn('FieldNumber', {
                                error: errors?.PickupEtaMinutes
                              })}
                              type='text'
                              value={values.PickupEtaMinutes}
                              onChange={(event) =>
                                setFieldValue(
                                  'PickupEtaMinutes',
                                  etaFormatter(event.target.value)
                                )
                              }
                              onPaste={(e) => {
                                e.preventDefault();
                                return false;
                              }}
                              // onBlur={(event) => {
                              //   !Number(event.target.value) &&
                              //     setFieldValue('PickupEtaMinutes', 1);
                              // }}
                              name='PickupEtaMinutes'
                              placeholder='Food Preparation Time'
                            />
                            <ErrorSignWrapper>
                              <ErrorSign>
                                {errors.PickupEtaMinutes &&
                                  errors.PickupEtaMinutes}
                              </ErrorSign>
                            </ErrorSignWrapper>
                            <DashboardText className='mLeft20 mobMinLeft'>
                              minutes
                            </DashboardText>
                            <ButtonInfo className='Outline ButtonInfoDrop'>
                              <div className='DropInfo DropInfoCenter disabled DropInfoRightMob'>
                                The average time required to prepare the food.
                              </div>
                            </ButtonInfo>
                          </DashboardField>

                          <DashboardField className='w100'>
                            <CheckboxS2E
                              onChange={(e) => {
                                const {checked} = e.target;
                                setFieldValue(
                                  'DeliveryOptions.Curbside',
                                  checked
                                );
                              }}
                              name={'DeliveryOptions.Curbside'}
                              checked={
                                values.DeliveryOptions.Curbside &&
                                values.DeliveryOptions.Pickup
                              }
                              label={'Curbside Pickup'}
                            />
                          </DashboardField>
                          {values.DeliveryOptions.Curbside &&
                            values.DeliveryOptions.Pickup && (
                              <>
                                <DashboardField className='flexColumn AlignStart w30Plus'>
                                  <FieldLabel>Curbside Instructions</FieldLabel>
                                  <FieldInput
                                    type='text'
                                    value={
                                      values.DeliveryOptions
                                        ?.CurbsideInstructions
                                    }
                                    onChange={handleChange}
                                    name='DeliveryOptions.CurbsideInstructions'
                                    placeholder='Please send us your car model and color'
                                    maxLength='40'
                                  />
                                </DashboardField>

                                <DashboardField className='flexColumn AlignStart w30Plus'>
                                  <FieldLabel>
                                    Curbside Additional Information
                                  </FieldLabel>
                                  <FieldInput
                                    type='text'
                                    value={
                                      values.DeliveryOptions
                                        ?.CurbsideAdditionalInformation
                                    }
                                    onChange={handleChange}
                                    name='DeliveryOptions.CurbsideAdditionalInformation'
                                    placeholder='Car: '
                                    maxLength='40'
                                  />
                                </DashboardField>
                              </>
                            )}
                        </DashboardFields>
                      </DashboardFieldInner>
                    </DashboardField>

                    <DashboardField className='w100 dFlex mTop'>
                      <DashboardFieldLabel>
                        <div>
                          <SwitchS2E
                            onChange={() => onServiceChange('Delivery', values)}
                            name='DeliveryOptions.Delivery'
                            checked={values.DeliveryOptions.Delivery}
                            label='Delivery'
                            labelPlacement='start'
                            isDisabled={
                              !checkIfSauceEmployee() && !InhouseDelivery
                            }
                          />
                          <ErrorSign>
                            {values?.DeliveryOptions?.Delivery === false &&
                              getServiceDisabledHint(values?.DeliveryEnableIn)}
                          </ErrorSign>
                        </div>
                      </DashboardFieldLabel>
                      <DashboardFieldInner
                        className={
                          !values.DeliveryOptions.Delivery
                            ? 'disabled w60 dFlex'
                            : 'w60 dFlex'
                        }
                      >
                        <RadioGroup
                          aria-label='Delivery'
                          name='checkedDiscount'
                        >
                          <DashboardFields>
                            <FlexContainer>
                              <FlexItem>
                                <DashboardField className='w100 dFlex opacity04'>
                                  <RadioS2E
                                    type='radio'
                                    label='Sauce Dispatch'
                                    name='Say2eatDispatch'
                                    checked={
                                      values.Say2eatDispatch &&
                                      !values.InhouseDelivery &&
                                      values.DeliveryOptions.Delivery
                                    }
                                    value={values.Say2eatDispatch}
                                    onChange={() => {
                                      setFieldValue('Say2eatDispatch', true);
                                      setFieldValue('InhouseDelivery', false);
                                      setFieldValue('EtaMinutes', 60);
                                    }}
                                  />
                                  <DashboardText className='mLeft20'>
                                    Dynamic ETA
                                  </DashboardText>
                                  <ButtonInfo className='Outline ButtonInfoDrop'>
                                    <div className='DropInfo DropInfoCenter DropInfoRightMob'>
                                      With Sauce dispatch delivery method, the
                                      ETA will be dynamically calculated based
                                      on distance and driver availability.
                                    </div>
                                  </ButtonInfo>
                                </DashboardField>
                                <DashboardField className='w100 dFlex'>
                                  <RadioS2E
                                    type='radio'
                                    value={values.InhouseDelivery}
                                    label='Inhouse Delivery'
                                    name='InhouseDelivery'
                                    className='opacity04'
                                    checked={
                                      values.InhouseDelivery &&
                                      !values.Say2eatDispatch &&
                                      values.DeliveryOptions.Delivery
                                    }
                                    onChange={() => {
                                      setFieldValue('InhouseDelivery', true);
                                      setFieldValue('Say2eatDispatch', false);
                                    }}
                                  />
                                  <DashboardField
                                    className={cn('dFlex', {
                                      opacity04: !values.InhouseDelivery,
                                      opacity1: values.InhouseDelivery
                                    })}
                                  >
                                    <DashboardText className='bold mRight20 '>
                                      ETA
                                    </DashboardText>

                                    <FieldInput
                                      className={cn('FieldNumber', {
                                        error:
                                          errors.EtaMinutes &&
                                          values.InhouseDelivery,
                                        isDisabled: !values.InhouseDelivery
                                      })}
                                      disabled={!values.InhouseDelivery}
                                      type='text'
                                      value={values.EtaMinutes}
                                      onChange={(event) =>
                                        setFieldValue(
                                          'EtaMinutes',
                                          etaFormatter(
                                            event.target.value,
                                            values.PickupEtaMinutes
                                          )
                                        )
                                      }
                                      onPaste={(e) => {
                                        e.preventDefault();
                                        return false;
                                      }}
                                      onBlur={(event) => {
                                        !Number(event.target.value) &&
                                          setFieldValue('EtaMinutes', 1);
                                      }}
                                      name='EtaMinutes'
                                      placeholder='ETA'
                                    />
                                    <ErrorSignWrapper leftPosition='54px'>
                                      <ErrorSign>
                                        {errors.EtaMinutes &&
                                          values.InhouseDelivery &&
                                          errors.EtaMinutes}
                                      </ErrorSign>
                                    </ErrorSignWrapper>
                                    <DashboardText className='mLeft20'>
                                      minutes
                                    </DashboardText>
                                    <ButtonInfo className='Outline ButtonInfoDrop'>
                                      <div className='DropInfo DropInfoCenter DropInfoRightMob'>
                                        The average time required to deliver the
                                        food is based on your delivery service.
                                      </div>
                                    </ButtonInfo>
                                  </DashboardField>
                                </DashboardField>
                              </FlexItem>
                            </FlexContainer>
                          </DashboardFields>
                        </RadioGroup>
                      </DashboardFieldInner>
                    </DashboardField>
                  </DashboardFields>
                </DashboardHolder>
                <DashboardHolder>
                  <DashboardTitle className='WithLine mBottom titleMd'>
                    General Settings
                  </DashboardTitle>
                  <DashboardFields>
                    <DashboardField className='w100 dFlex'>
                      <DashboardFieldLabel className='DashboardFieldLabelCenter'>
                        <FieldLabel className='FieldLabelLg'>
                          Location Phone Number
                        </FieldLabel>
                      </DashboardFieldLabel>
                      <DashboardFieldInner className='w100Auto'>
                        <DashboardFields className='noWrap'>
                          <DashboardField className='FieldNumber'>
                            <FieldLabel>
                              Country Code <span>*</span>
                            </FieldLabel>
                            <FieldInput
                              onBlur={handleBlur}
                              disabled
                              value={
                                values.CountryCode === '+'
                                  ? '+1'
                                  : values.CountryCode
                              }
                              onChange={(e) => {
                                const code = countryCodeFormatter(
                                  e.target.value
                                );
                                setFieldValue('CountryCode', code);
                              }}
                              name='CountryCode'
                              placeholder='+1'
                              className={cn({
                                error:
                                  errors?.CountryCode && touched?.CountryCode
                              })}
                            />
                            <ErrorSignWrapper>
                              {errors?.CountryCode && touched?.CountryCode ? (
                                <ErrorSign>{errors?.CountryCode}</ErrorSign>
                              ) : null}
                            </ErrorSignWrapper>
                          </DashboardField>
                          <DashboardField className='wAutoSpace'>
                            <FieldLabel>
                              Your phone number <span>*</span>
                            </FieldLabel>
                            <FieldMaskInput
                              mask='(999) 999-9999'
                              value={values.Phone}
                              onChange={(e) => {
                                const code = phoneNumberFormatter(
                                  e.target.value
                                );
                                setFieldValue('Phone', code);
                              }}
                              name='Phone'
                              placeholder='Your phone number'
                              className={cn({
                                error: errors?.Phone && touched?.Phone
                              })}
                              onBlur={(e) => {
                                const regExp = /^\([2-9][\d]{2}\) [2-9][\d]{2}-[\d]{1,}$/g;
                                if (!regExp.test(e.target.value)) {
                                  setFieldValue('Phone', '');
                                  setErrors({
                                    ...errors,
                                    Phone: 'Incorrect phone format'
                                  });
                                }
                                handleBlur(e);
                              }}
                            />
                            <ErrorSignWrapper leftPosition='12px'>
                              {errors?.Phone && touched?.Phone ? (
                                <ErrorSign>{errors?.Phone}</ErrorSign>
                              ) : null}
                            </ErrorSignWrapper>
                          </DashboardField>
                        </DashboardFields>
                        <DashboardInnerDescription className='DashboardInnerDescription'>
                          Will be presented to your customers
                        </DashboardInnerDescription>
                      </DashboardFieldInner>
                    </DashboardField>

                    <DashboardField className='w100 dFlex'>
                      <DashboardFieldLabel>
                        <FieldLabel className='FieldLabelLg'>
                          Mail For Weekly Report
                        </FieldLabel>
                      </DashboardFieldLabel>
                      <DashboardField className='wAutoSpace paddingL0'>
                        <FieldInput
                          value={values.MailForWeeklyReport}
                          onChange={(e) => {
                            const {
                              target: {value}
                            } = e;
                            if (value === '') {
                              setFieldValue('MailForWeeklyReport', null);
                              return;
                            }
                            handleChange(e);
                          }}
                          name='MailForWeeklyReport'
                          onBlur={handleBlur}
                          placeholder='Mail For Weekly Report'
                          className={cn({
                            error:
                              errors?.MailForWeeklyReport &&
                              touched?.MailForWeeklyReport
                          })}
                        />
                        <ErrorSignWrapper leftPosition='0'>
                          {errors?.MailForWeeklyReport &&
                          touched?.MailForWeeklyReport ? (
                            <ErrorSign>
                              {errors?.MailForWeeklyReport || 'Empty'}
                            </ErrorSign>
                          ) : null}
                        </ErrorSignWrapper>
                      </DashboardField>
                      <ButtonInfo className='Outline ButtonInfoDrop marginLeftXsPlus'>
                        <div className='DropInfo DropInfoRight DropInfoRightMob'>
                          You can enter more than one email separated by commas.
                          For example: sauce1@test.com, sauce2@test.com
                        </div>
                      </ButtonInfo>
                    </DashboardField>
                    {showSelfDeliveryReportEmail && (
                      <DashboardField className='w100 dFlex'>
                        <DashboardFieldLabel>
                          <FieldLabel className='FieldLabelLg'>
                            Mail For Self-Delivery Report
                          </FieldLabel>
                        </DashboardFieldLabel>
                        <DashboardField className='wAutoSpace paddingL0'>
                          <FieldInput
                            value={
                              selfDeliveryReportEmailLoading
                                ? ''
                                : selfDeliveryReportEmail || ''
                            }
                            name='MailForSelfDeliveryReport'
                            placeholder={
                              selfDeliveryReportEmailLoading
                                ? 'Loading...'
                                : 'Mail For Self-Delivery Report'
                            }
                            disabled
                            onChange={() => {}}
                            readOnly
                          />
                          {canUpdateSelfDeliveryReportEmail && (
                            <SelfDeliveryReportEmailHint>
                              Want to change this email address?{' '}
                              <button
                                type='button'
                                onClick={openSelfDeliveryEmailChangeModal}
                              >
                                Click here to change it
                              </button>
                            </SelfDeliveryReportEmailHint>
                          )}
                        </DashboardField>
                      </DashboardField>
                    )}
                    {/* <DashboardField className='w100 dFlex'>
                      <DashboardFieldLabel>
                        <FieldLabel className='FieldLabelLg'>
                          Mail For Human Response Message
                        </FieldLabel>
                      </DashboardFieldLabel>
                      <DashboardFieldInner className='w60FLex'>
                        <FieldInput
                          value={values.MailForHumanResponseMessage}
                          onChange={(e) => {
                            const {
                              target: {value}
                            } = e;
                            if (value === '') {
                              setFieldValue(
                                'MailForHumanResponseMessage',
                                null
                              );
                              return;
                            }
                            handleChange(e);
                          }}
                          name='MailForHumanResponseMessage'
                          onBlur={handleBlur}
                          placeholder='Mail For Human Response Message'
                          className={cn({
                            error:
                              errors?.MailForHumanResponseMessage &&
                              touched?.MailForHumanResponseMessage
                          })}
                        />
                        <ErrorSignWrapper leftPosition='210px'>
                          {errors?.MailForHumanResponseMessage &&
                          touched?.MailForHumanResponseMessage ? (
                            <ErrorSign>
                              {errors?.MailForHumanResponseMessage || 'Empty'}
                            </ErrorSign>
                          ) : null}
                        </ErrorSignWrapper>
                      </DashboardFieldInner>
                    </DashboardField> */}
                  </DashboardFields>
                </DashboardHolder>

                {showBillingBank && (
                  <BillingBank
                    locationId={activeLocation?._id}
                    connected={bankAccountConnected}
                    lastFour={bankAccountLast4}
                    companyFound={bankAccountCompanyFound}
                  />
                )}

                <div style={{position: 'relative'}}>
                  <ErrorSignWrapper
                    topPosition='22px'
                    leftPosition='1px'
                    zIndex='2'
                  >
                    <ErrorSign>
                      {errors.EtaMinutes &&
                        !values.InhouseDelivery &&
                        errors.EtaMinutes}
                    </ErrorSign>
                  </ErrorSignWrapper>
                </div>

                <DaysPickerContainer WorkingDays={WorkingDays} />

                {AllowedServiceFeatures.includes('delivery_hours') && (
                  <DashboardHolder>
                    <DashboardTitle className='WithLine mBottom titleMd'>
                      Delivery Hours
                    </DashboardTitle>
                    <DashboardField className='w100 dFlex mTop'>
                      <DashboardFieldLabel>
                        <div>
                          <SwitchS2E
                            onChange={handleChange}
                            name='DeliveryHoursSuchAsOpeningHours'
                            checked={values.DeliveryHoursSuchAsOpeningHours}
                            label='Same as Opening Hours'
                            labelPlacement='start'
                          />
                        </div>
                      </DashboardFieldLabel>
                    </DashboardField>
                    {!values.DeliveryHoursSuchAsOpeningHours && (
                      <DeliveryDaysPickerContainer
                        DeliveryDays={DeliveryDays}
                      />
                    )}
                  </DashboardHolder>
                )}

                <DashboardHolder>
                  <DashboardTitle className='WithLine mBottom titleMd'>
                    Tax
                  </DashboardTitle>
                  <DashboardFields>
                    <DashboardField className='w100'>
                      <FieldArray name='TaxPercents'>
                        {({remove, push}) => (
                          <>
                            {values.TaxPercents.length > 0 &&
                              values.TaxPercents.map((tax, index) => (
                                <FlexItem>
                                  <DashboardFieldInner className='w10'>
                                    <DashboardFields>
                                      <DashboardField
                                        key={`taxName-${index + 1}`}
                                      >
                                        <FieldLabel className='FW400 FieldLabelLg'>
                                          Tax Name
                                        </FieldLabel>
                                        <FieldInput
                                          className={cn('FieldTaxName', {
                                            error:
                                              errors.TaxPercents &&
                                              errors?.TaxPercents[index]?.Name
                                          })}
                                          type='text'
                                          value={tax.Name}
                                          name={`TaxPercents[${index}].Name`}
                                          onChange={handleChange}
                                          placeholder='Enter tax name'
                                        />
                                        <ErrorSignWrapper>
                                          <ErrorSign>
                                            {errors.TaxPercents &&
                                              errors?.TaxPercents[index]
                                                ?.Name &&
                                              errors?.TaxPercents[index]?.Name}
                                          </ErrorSign>
                                        </ErrorSignWrapper>
                                      </DashboardField>
                                      <DashboardField
                                        key={`taxValue-${index + 1}`}
                                      >
                                        <FieldLabel className='FW400 FieldLabelLg'>
                                          Tax Rate %
                                        </FieldLabel>
                                        <FieldInput
                                          className={cn('FieldTaxName', {
                                            error:
                                              errors.TaxPercents &&
                                              errors?.TaxPercents[index]?.Value
                                          })}
                                          type='text'
                                          value={tax.Value}
                                          name={`TaxPercents[${index}].Value`}
                                          onChange={(event) => {
                                            setFieldValue(
                                              `TaxPercents.${index}.Value`,
                                              taxFormatter(
                                                event.target.value,
                                                tax.Value
                                              )
                                            );
                                          }}
                                          placeholder='Tax Rate %'
                                        />
                                        <ErrorSignWrapper>
                                          <ErrorSign>
                                            {errors.TaxPercents &&
                                              errors?.TaxPercents[index]
                                                ?.Value &&
                                              errors?.TaxPercents[index]?.Value}
                                          </ErrorSign>
                                        </ErrorSignWrapper>
                                        {values.TaxPercents.length > 1 && (
                                          <DashboardTimeInner className='DashboardTimeDelete pRight'>
                                            <DashboardTimeDelete
                                              type='button'
                                              onClick={() => remove(index)}
                                            />
                                          </DashboardTimeInner>
                                        )}
                                      </DashboardField>
                                    </DashboardFields>
                                  </DashboardFieldInner>
                                </FlexItem>
                              ))}
                            {values.TaxPercents.length < 5 && (
                              <DashboardField className='dFlex justifyCenter'>
                                <DialogLinkButton
                                  className={computedAddTaxButtonClasses(
                                    values.TaxPercents
                                  )}
                                  onClick={() => push({Name: '', Value: ''})}
                                  type='button'
                                >
                                  Add Another Tax
                                </DialogLinkButton>
                              </DashboardField>
                            )}
                          </>
                        )}
                      </FieldArray>
                    </DashboardField>
                    <DashboardField className='w100 dFlex'>
                      <FieldLabel className='FieldLabelLg marginRightSm'>
                        Alcohol Tax
                      </FieldLabel>
                      <FieldInput
                        className='FieldNumber'
                        type='text'
                        name='AlcoholTax'
                        value={values.AlcoholTax}
                        onChange={(event) => {
                          setFieldValue(
                            'AlcoholTax',
                            taxFormatter(event.target.value, values.AlcoholTax)
                          );
                        }}
                        placeholder='Tax %'
                      />
                      <FieldLabel className='FieldLabelLg FW400 marginLeftXs'>
                        %
                      </FieldLabel>
                    </DashboardField>
                  </DashboardFields>
                </DashboardHolder>
                <DashboardHolder>
                  <DashboardTitle className='WithLine mBottom titleMd'>
                    Address
                  </DashboardTitle>
                  <DashboardFields>
                    <DashboardField className='w60Plus withClear'>
                      <AutocompletedMapField
                        type='text'
                        value={values.Address}
                        onChange={handleChange}
                        name='Address'
                        fieldToClear='FullAddress'
                        placeholder='Address'
                        setFieldValue={setFieldValue}
                        map={map}
                        mapMarker={mapMarker}
                        className={cn('AutoComplete', {
                          error: errors.Address || errors.StreetNumber
                        })}
                        structuredAddress={values.StructuredAddress}
                      />
                      {!!values.Address && (
                        <ButtonClear
                          onClick={() => {
                            setFieldValue('Location', {});
                            setFieldValue('FullAddress', '');
                            setFieldValue('Address', '');
                            setFieldValue('Country', '');
                            setFieldValue('State', '');
                            setFieldValue('PlaceId', '');
                            setFieldValue('City', '');
                            setFieldValue('Street', '');
                            setFieldValue('ZipCode', '');
                            setFieldValue('StreetNumber', '');
                          }}
                        />
                      )}
                      <ErrorSignWrapper>
                        <ErrorSign>
                          {errors.Address
                            ? errors.Address
                            : errors.StreetNumber && errors.StreetNumber}
                        </ErrorSign>
                      </ErrorSignWrapper>
                    </DashboardField>

                    <DashboardField className='w60Plus'>
                      <LocationMap
                        center={mapProps.center}
                        zoom={mapProps.zoom}
                        values={values}
                        setFieldValue={setFieldValue}
                        setMap={setMap}
                        map={map}
                        mapMarker={mapMarker}
                        setMapMarker={setMapMarker}
                        isCreating={isCreating}
                      />
                    </DashboardField>
                  </DashboardFields>
                </DashboardHolder>
                <DashboardHolder>
                  <DashboardTitle className='WithLine mBottom titleMd'>
                    Menu page banner
                  </DashboardTitle>
                  <DashboardInnerDescription className='withIcon GreyText marginB15'>
                    <span>
                      Add a message shown at the top of your Storefront menu
                      page — great for promotions, holiday hours, or delivery
                      notices. Max 1000 characters.
                    </span>
                  </DashboardInnerDescription>
                  <DashboardFields>
                    <DashboardField className='w60Plus'>
                      <MenuBannerField>
                        <Textarea
                          style={{resize: 'none'}}
                          className={cn('FieldTextareaLg', {
                            error: errors.MenuBannerText
                          })}
                          value={values.MenuBannerText}
                          onChange={handleChange}
                          name='MenuBannerText'
                          placeholder='e.g. **Holiday hours:** We close at 6pm on July 4th. Free delivery on orders over $25!'
                        />
                        <ErrorSignWrapper topPosition='-20px' leftPosition='0'>
                          <ErrorSign>
                            {errors.MenuBannerText && errors.MenuBannerText}
                          </ErrorSign>
                        </ErrorSignWrapper>
                        <p className='MenuBannerCounter'>
                          {values.MenuBannerText?.length || 0}/1000
                        </p>
                      </MenuBannerField>
                    </DashboardField>
                  </DashboardFields>
                </DashboardHolder>
                <StorefrontQrCode />
              </DashboardDisableStore>
              <LocationFormActions
                className={cn('LocationFormActions', {
                  PublishOverlay: messageUnPublish
                })}
              >
                <div className='LocationFormSave'>
                  <ButtonPrimary
                    type='submit'
                    className={cn('saveChanges ButtonSave ButtonMedium', {
                      disabled:
                        disableButton ||
                        (formSubmitting
                          ? true
                          : showUnPublishBannerType ===
                            UNPUBLISH_BANNER_SETTINGS_TYPE
                          ? false
                          : !dirty)
                    })}
                  >
                    <SaveButton />
                    <span>Save</span>
                  </ButtonPrimary>
                  <RouteLeavingGuardNew
                    iconMessage={<IconSaveDisk />}
                    messageUnPublish={messageUnPublish}
                    setMessageUnPublish={setMessageUnPublish}
                    confirmedNavigation={confirmedNavigation}
                    when={dirty}
                    titleText={
                      'Are you sure you want to leave this page without saving?'
                    }
                    buttonCancel={
                      <ButtonBold
                        className='Grey'
                        onClick={closePublishMessage}
                      >
                        Leave
                      </ButtonBold>
                    }
                    buttonConfirm={
                      <ButtonBold
                        onClick={async () => {
                          setMessageUnPublish(false);
                          await submitForm();
                        }}
                      >
                        Save
                      </ButtonBold>
                    }
                    navigate={(path) => {
                      if (dirty) {
                        sendGtmEvent('storeSettingsUnsavedChanges', {
                          unsaved: true
                        });
                      }
                      history.push(path);
                    }}
                  />
                </div>
                {/*<LocationPublishButton isSubmitting={formSubmitting} />*/}
              </LocationFormActions>
              <ButtonSaveScroll
                type='submit'
                className={cn({
                  disabled:
                    disableButton ||
                    (formSubmitting
                      ? true
                      : showUnPublishBannerType ===
                        UNPUBLISH_BANNER_SETTINGS_TYPE
                      ? false
                      : !dirty)
                })}
              />
            </Form>
          </DashboardFormWrapper>
        );
      }}
    </Formik>
  );
};

LocationForm.propTypes = {
  isCreating: T.bool.isRequired,
  setIsCreating: T.func.isRequired,
  setConfirmedNavigation: T.func.isRequired
};

LocationForm.defaultProps = {};

export default memo(LocationForm);
